<template>
    <div class="full-width">
        <div layout="column" layout-align="start start" class="full-width mb20-pc px2-pc pb1-pc mb2-mobile px1-mobile bg-white">
            <div layout="row" layout-align="start center" class="title grey--text text-uppercase font-weight-medium mb2-pc mb1-mobile mt3-pc full-width">{{$t('nav.schools')}}
                <v-btn @click="displayFilters = !displayFilters" icon class="hidden-md-and-up ml-1"><i :class="['mdi', displayFilters ? 'mdi-filter-remove' : 'mdi-filter']" style="color: black"></i></v-btn>
            </div>
            <div v-if="!$vuetify.breakpoint. smAndDown || displayFilters" layout="row" layout-wrap layout-align="start center" class="full-width" flex="100">
                <div layout="column" :flex="$vuetify.breakpoint. smAndDown ? 100 : 33">
                    <v-select
                        :label="$t('params.sectors')"
                        :hint="$t('filters.sectors_select')"
                        persistent-hint multiple
                        solo v-model="filters.sector"
                        :items="sectors"
                        @change="fetch"
                        class="mr5-pc width-100-mobile"
                    >
                    </v-select>
                </div>
                <div layout="column" :flex="$vuetify.breakpoint. smAndDown ? 100 : 33">
                    <v-select
                        :label="$t('params.rds')"
                        :hint="$t('filters.rds_select')"
                        persistent-hint multiple
                        solo v-model="filters.regional_directorate_id"
                        :items="rds" item-value="id" :item-text="itemLabel"
                        @change="fetch" autocomplete
                        class="mr5-pc ml5-pc width-100-mobile"
                    >
                    </v-select>
                </div>
                <div layout="column" :flex="$vuetify.breakpoint. smAndDown ? 100 : 33">
                    <v-select
                        :label="$t('params.regions')"
                        :hint="$t('filters.regions_select')"
                        persistent-hint multiple
                        solo v-model="filters.region_id"
                        :items="regions" item-value="id" :item-text="itemName"
                        @change="fetch"
                        class="ml5-pc width-100-mobile"
                        autocomplete
                    >
                    </v-select>
                </div>
                <div layout="column" :flex="$vuetify.breakpoint. smAndDown ? 100 : 33">
                    <v-select
                        :label="$t('params.cities')"
                        :hint="$t('filters.cities_select')"
                        persistent-hint multiple
                        solo v-model="filters.city_id"
                        :items="$store.state.cities" item-value="id" item-text="label"
                        @change="fetch"
                        class="mr5-pc width-100-mobile"
                        autocomplete
                    >
                    </v-select>
                </div>
                <div layout="column" :flex="$vuetify.breakpoint. smAndDown ? 100 : 33">
                    <v-select
                        :label="$t('filters.status')"
                        :hint="$t('filters.status_hint')"
                        persistent-hint
                        solo v-model="filters.is_enabled"
                        :items="status"
                        @change="fetch"
                        class="mr5-pc ml5-pc width-100-mobile"
                    >
                    </v-select>
                </div>
                <div layout="column" :flex="$vuetify.breakpoint. smAndDown ? 100 : 33">
                    <v-text-field solo :label="$t('filters.keywords')" :hint="$t('filters.schools_hint')" persistent-hint v-model="filters.keywords" @keyup.enter="fetch" class="ml5-pc width-100-mobile"></v-text-field>
                </div>
                <div layout="column" :flex="$vuetify.breakpoint. smAndDown ? 100 : 33">
                    <v-checkbox @change="fetch" v-model="filters.no_representative" :false-value="0" :true-value="1" class="width-100-mobile" :label="$t('schools.no_rep_filter')"></v-checkbox>
                </div>

                <div layout="column" flex="$vuetify.breakpoint. smAndDown ? 0 : 66">&nbsp;</div>
                <span flex></span>
                <v-btn depressed color="secondary" @click="fetch" large>{{$t('filters.filter_btn')}}</v-btn>
                {{$t('_.or')}}
                <a href="#" class="ml-2 black--text" @click.prevent="resetFilters">{{$t('filters.reinit')}}</a>
            </div>
        </div>
        <div layout="column" layout-align="start start" class="full-width pt3-pc pb5-pc px2-pc pa1-mobile bg-white">
            <div class="font-weight-bold full-width">
                <span class="secondary--text">{{total}}</span>&nbsp;
                <span v-if="total > 1">
                    <span class="text-lowercase">{{$t('schools.title')}}</span>
                    {{$t('filters.match_pl')}} {{$t('filters.criteria')}}
                </span>
                <span v-else>
                    <span class="text-lowercase">{{$t('schools.school')}}</span>
                    {{$t('filters.match')}} {{$t('filters.criteria')}}
                </span>
            </div>

            <div class="mt-1 full-width">
                <v-btn class="ml-0" flat outline color="secondary" :to="{name: 'admin-schools-edit', params: {id: 'new'}}">
                    <span style="text-transform: none">{{$t('schools.add_btn')}}</span>
                </v-btn>
            </div>
            <div layout="row" layout-align="start center" layout-wrap class="full-width mt-3">
                <v-card v-for="s in schools" layout="row" layout-align="start center" class="school-card pr1-pc mt3-pc" flat :to="``" :flex="$vuetify.breakpoint. smAndDown ? 100 : 50" :key="'school_'+s.id">
                    <div @click.prevent="$router.push({name: 'admin-schools-show', params: {id: s.id}})" class="ctn diamond-shape clickable" :class="[s.is_enabled ? '' : 'disabled']">
                        <span class="white--text item">
                            <v-icon size="48" :color="s.is_enabled ? 'secondary lighten-2' : '#cccccc'" class="school-icon">mdi-city</v-icon>
                        </span>
                    </div>

                    <div @click.prevent="$router.push({name: 'admin-schools-show', params: {id: s.id}})" class="clickable" layout="column" flex>
                        <div layout="row" layout-align="start center" class="subheading font-weight-bold pl-1">
                            {{ s.name }}
                            <v-icon v-if="!s.nb_representatives" color="warning" :title="$t('schools.no_rep_info')">mdi-alert</v-icon>
                            <v-chip v-if="!s.is_enabled" class="ml-2" color="error" text-color="white" small>
                                {{$t('_.disabled_f')}}
                            </v-chip>
                        </div>
                        <div v-if="s.city" class="caption hidden-sm-and-down pl-1" layout="row" layout-align="start center">
                            <v-icon class="mr-1">mdi-map-marker</v-icon>{{s.city.label}}
                        </div>
                        <div v-if="s.contact_fullname" class="caption hidden-sm-and-down pl-1" layout="row" layout-align="start center">
                            <v-icon class="mr-1">mdi-account</v-icon>{{s.contact_fullname.trim() ? s.contact_fullname : " - "}}
                        </div>
                        <div layout="row" layout-wrap layout-align="start center">
                            <v-chip v-for="se in s.sectors" label :color="sectorColor(se.sector)" text-color="white" :key="s.id + se.id" small>
                                {{sectorLabel(se.sector)}}
                            </v-chip>
                        </div>
                    </div>
                    <div layout="column">
                        <div :layout="$vuetify.breakpoint. smAndDown ? 'column' : 'row'" layout-align="center center">
                            <v-btn :title="$t('_.edit')" class="mx-0 ma0-mobile" icon :to="{name: 'admin-schools-edit', params: {id: s.id}}"><v-icon color="secondary">mdi-pencil</v-icon></v-btn>
                            <v-btn :title="s.is_enabled ? $t('_.disable') : $t('_.enable')" class="mx-0 ma0-mobile" icon @click="toggle(s)">
                                <v-icon color="secondary">{{ s.is_enabled ? 'mdi-lock-outline': 'mdi-lock-open-outline' }}</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </v-card>
            </div>
            <div class="text-xs-center mt-5 full-width">
                <v-pagination
                v-model="filters.page"
                :length="pages" color="secondary"
                total-visible="5"
                @input="fetch"
                ></v-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import Params from '@/api/params'
    import Schools from '@/api/schools'
    import I18nMixin from '@/mixins/i18n'
    import Consts from '@/consts'

    export default {
        mixins: [I18nMixin],
        data () {
            return {
                storeKey: 'schools',
                filters: {
                    keywords: null,
                    is_enabled: 1,
                    sector: [],
                    city_id: [],
                    regional_directorate_id: [],
                    region_id: [],
                    no_representative: 0,
                    rowsPerPage: 10,
                    descending: 0,
                    sortBy: 'name',
                    page: 1
                },
                schools: [],
                regions: [],
                rds: [],
                displayFilters: false,
                total: 0
            }
        },
        mounted() {
            const storedFilters = this.$store.getters.getFilters(this.storeKey)
            if (storedFilters) {
              this.filters = storedFilters
            }

            this.fetch();
            this.fetchParams();
        },
        methods: {
            fetch () {
                Schools.getList(this.filters).then(res => {
                  this.schools = res.data.items;
                  this.total = res.data.total;
                  this.$store.commit('SET_FILTERS', {key: this.storeKey, data: this.filters})
                })
            },
            fetchParams () {
                Params.getList('regional-directorates', {is_enabled: 1}).then(res => {
                    this.rds = res.data;
                    this.rds = this.rds.sort((a,b) => (this.i18n(a.label) > this.i18n(b.label)) ? 1 : ((this.i18n(b.label) > this.i18n(a.label)) ? -1 : 0));
                })
                Params.getList('regions', {is_enabled: 1}).then(res => {
                    this.regions = res.data;
                    this.regions = this.regions.sort((a,b) => (this.i18n(a.name) > this.i18n(b.name)) ? 1 : ((this.i18n(b.name) > this.i18n(a.name)) ? -1 : 0));
                })
            },

            resetFilters () {
                this.filters = {
                    keywords: null,
                    is_enabled: 1,
                    sector: [],
                    city_id: [],
                    regional_directorate_id: [],
                    region_id: [],
                    no_representative: 0,
                    rowsPerPage: 10,
                    descending: 0,
                    sortBy: 'name',
                    page: 1
                };
                this.fetch();
            },
            toggle (item) {
                if (item.is_enabled) {
                    Schools.disable(item.id).then(() => {
                        this.fetch();
                        this.$snotify.success(this.$t('schools.disable'))
                    })
                } else {
                    Schools.enable(item.id).then(() => {
                        this.fetch();
                        this.$snotify.success(this.$t('schools.enable'))
                    })
                }
            },
            itemName(item){
                return this.i18n(item.name);
            },
            itemLabel(item){
                return this.i18n(item.label);
            },
            sectorLabel(s){
                switch (s) {
                    case Consts.PRIMARY:
                        return this.$t('schools.sector_prim');
                    case Consts.SECONDARY:
                        return this.$t('schools.sector_sec');
                    case Consts.COMPETENCECENTRE:
                        return this.$t('schools.sector_comp');
                }
            },
            sectorColor(s){
                switch (s) {
                    case Consts.PRIMARY:
                        return 'secondary';
                    case Consts.SECONDARY:
                        return 'primary';
                    case Consts.COMPETENCECENTRE:
                        return 'warning';
                }
            },
        },
        computed: {
            sectors () {
                return [
                    { value: Consts.PRIMARY, text: this.$t('schools.sector_prim') },
                    { value: Consts.SECONDARY, text: this.$t('schools.sector_sec') },
                    { value: Consts.COMPETENCECENTRE, text: this.$t('schools.sector_comp') },
                ]
            },
            status () {
                return [
                    { value: null, text: this.$t('filters.status_all') },
                    { value: 1, text: this.$t('filters.status_active') },
                    { value: 0, text: this.$t('filters.status_inactive') },
                ]
            },
            pages () {
                return Math.ceil(this.total / this.filters.rowsPerPage);
            }
        }
    }
</script>
<style scoped>
.school-card > .avatar {
  border-radius: 50% !important;
  background: #589c8f;
}

.ctn {
  margin: 16px;
  text-align: center;
  width: 64px;
  height: 64px;
}
.diamond-shape {
  /*background: #589C8F;
  background-image:radial-gradient(10px, #589C8F, #37625a);*/
  text-align: center;
  transform: rotate(45deg);
  background: #eeeeee;
}
.item {
  display: flex;
  transform: rotate(-45deg);
  vertical-align: middle;
}

.square {
  -ms-transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  overflow: hidden;
}
.pic {
  -ms-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>
<style>
.school-icon {
  display: flex;
  line-height: initial;
}
</style>
